import { useEffect, useRef, useState } from 'react';

import type { AutocompleteOption } from '../../../types';

import { DEFAULT_OPTION } from '../utils/AutocompleteDefault';

interface useAutocompleteSelectionProps {
    options: AutocompleteOption[];
    showDefaultOption: boolean;
    onSelectOption: (opt: AutocompleteOption) => void;
    initial?: number;
}

export function useAutocompleteSelection({ options, showDefaultOption, onSelectOption, initial = -1 }: useAutocompleteSelectionProps) {
    const [selected, setSelected] = useState<number>(initial);
    const selectedRef = useRef(selected);

    useEffect(() => {
        selectedRef.current = selected;
    }, [selected]);

    const resetSelection = () => setSelected(-1);

    const selectCurrentOption = () => {
        if (selected === 0 && showDefaultOption) {
            onSelectOption(DEFAULT_OPTION);
            return DEFAULT_OPTION;
        }

        const offset = showDefaultOption ? 1 : 0;
        const index = selected - offset;

        if (index >= 0 && index < options.length) {
            const opt = options[index];
            onSelectOption(opt);

            return opt;
        }

        return null;
    };

    return {
        selected,
        setSelected,
        selectedRef,
        resetSelection,
        selectCurrentOption,
    };
}
